__turbopack_export_value__({
  "content": "section-backdrop-module__D8eXUq__content",
  "gifts": "section-backdrop-module__D8eXUq__gifts",
  "location": "section-backdrop-module__D8eXUq__location",
  "rsvp": "section-backdrop-module__D8eXUq__rsvp",
  "schedule": "section-backdrop-module__D8eXUq__schedule",
  "section": "section-backdrop-module__D8eXUq__section",
});
